import { render, staticRenderFns } from "./GiveawayList.vue?vue&type=template&id=0c6d7a65&scoped=true&"
import script from "./GiveawayList.vue?vue&type=script&lang=js&"
export * from "./GiveawayList.vue?vue&type=script&lang=js&"
import style0 from "./GiveawayList.vue?vue&type=style&index=0&id=0c6d7a65&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6d7a65",
  null
  
)

export default component.exports